import { getTransformedMarkers } from "../../../components/PrizeLocator/utils/index";
export const getUpdatedLocation = async (storeId, flotiqApi) => {
    const response = await flotiqApi.getStoreByExternalId(storeId);
    const markers = getTransformedMarkers(response.data);
    return { markers, storeId };
};
//# sourceMappingURL=getUpdatedLocation.js.map